import { useTranslation } from 'next-i18next';
import React, { useState, useEffect } from 'react';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import { getCookie, setCookie } from '@utils/cookieUtils';

const CookiePopup = () => {
    const { t } = useTranslation();
    const { platform } = useSiteInfo();
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        // 檢查是否已經同意過 cookie 政策
        const cookieConsent = getCookie('cookieConsent');
        if (!cookieConsent) {
            setShowPopup(true);
        }
    }, []);

    const handleAgree = () => {
        setCookie('cookieConsent', 'true', 365);
        // 隱藏彈窗
        setShowPopup(false);
    };

    if (!showPopup) {
        return null;
    }

    return (
        <div className="cookie-popup" data-layout={platform}>
            <div className="cookie-popup__container">
                <p className="cookie-popup__title">{t('lbl_CookieTitle')}</p>
                <div className="cookie-popup__content">
                    <p className="cookie-popup__text">
                        {t('lbl_Cookie')}
                    </p>
                    <div className="btn btn--primary" onClick={handleAgree}>
                        <span className="text">{t('lbl_IAgree')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CookiePopup;
